/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const brandService = {
  getList: (params: any) => request.get('/guidebook/custom-brand', { params }),
  getBrandById: (id: any) => request.get(`/guidebook/custom-brand/${id}`),
  createBrand: (data: any) => request.post('/guidebook/custom-brand', data),
  deleteBrand: (id: any) => request.delete(`/guidebook/custom-brand/${id}`),
  updateBrand: (id: any, data: any) =>
    request.put(`/guidebook/custom-brand/${id}`, data)
};

export default brandService;
